/* eslint-disable no-console */

import utils from "./utils";

const debug = true;

function logMsg() {
  if (debug) {
    for (var i = 0; i < arguments.length; i++) {
      console.log(arguments[i]);
    }
  }
}

/**
 * To send events to cct and member-api
 */
export function track(category, action, label) {
  // log to CCT
  window.parent.postMessage(
    {
      type: 'ANALYTICS_TRACK',
      payload: {
        type: "event",
        data: {
          category: category,
          action: action,
          label: label
        }
      }
    }, window.REACT_APP_PARENT_HOST
  );

  // log to member api
  const body = JSON.stringify({
    appType:'CCT',
    category: category,
    action: action,
    label: label
  });
  const config = {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'client_id': 'cct'
    },
    credentials: 'include',
    body: body
  };
  fetch(utils.getLogPath(), config);
}


export default {
  error: logMsg,
  info: logMsg,
  debug: logMsg,
  track: track
};

/* eslint-enable no-console */



// WEBPACK FOOTER //
// ./src/helpers/log.js